<div class="eventq-toggle-list">
  @if (loading()) {
    <div class="eventq-toggle-list__skeleton" aria-hidden="true">
      @for (index of skeletonIndexes(); track index) {
        <div class="eventq-toggle-list__skeleton-row">
          <div class="eventq-toggle-list__skeleton-switch"></div>
          <div class="eventq-toggle-list__skeleton-text">
            <div class="eventq-toggle-list__skeleton-block eventq-toggle-list__skeleton-block--label"></div>
            <div class="eventq-toggle-list__skeleton-block eventq-toggle-list__skeleton-block--hint"></div>
          </div>
        </div>
      }
    </div>
  } @else {
    @for (item of items(); track item.id) {
      <div
        class="eventq-toggle-list__row"
        [class.eventq-toggle-list__row--label-start]="resolvedLabelPosition(item) === 'start'"
        [class.eventq-toggle-list__row--label-end]="resolvedLabelPosition(item) === 'end'"
        [class.eventq-toggle-list__row--disabled]="!!item.disabled"
      >
        @if (resolvedLabelPosition(item) === 'start') {
          <div class="eventq-toggle-list__copy">
            <span class="eventq-toggle-list__label">{{ item.label }}</span>
            @if (item.description) {
              <span class="eventq-toggle-list__description">{{ item.description }}</span>
            }
          </div>
        }

        <eventq-boolean-toggle
          [label]="item.label"
          [showLabel]="false"
          [checked]="item.checked"
          [disabled]="!!item.disabled"
          [variant]="variant()"
          (checkedChange)="onToggle(item, $event)"
        />

        @if (resolvedLabelPosition(item) === 'end') {
          <div class="eventq-toggle-list__copy">
            <span class="eventq-toggle-list__label">{{ item.label }}</span>
            @if (item.description) {
              <span class="eventq-toggle-list__description">{{ item.description }}</span>
            }
          </div>
        }
      </div>
    }
  }
</div>
